/**
 * übernommen aus verlinktem Java-Code von https://ec.europa.eu/taxation_customs/tin/tinRequest.html
 * (https://ec.europa.eu/taxation_customs/tin/specs/TIN%20Algorithms-Public_sources.jar)
 */

export class ChAlgorithm {
  private static PATTERN = /\d{13}/;
  private static LENGTH_PATTERN = /^.{13}$/;

  private static resultToString(result: number): string | null {
    switch (result) {
      case 4:
        return 'Die TIN muss aus 13 Ziffern bestehen.';
      case 3:
        return 'Die eingegebene TIN ist ungültig.';
      case 2:
        return 'Die TIN muss aus 13 Ziffern bestehen.';
      case 1:
        return 'Die eingegebene TIN ist ungültig.';
      case 0:
        return null;

      case -1:
        return 'Die eingegebene TIN ist ungültig.';
      default:
        return 'Die eingegebene TIN ist ungültig.';
    }
  }

  private static getUnit(num: number): number {
    if (num < 0) {
      throw new Error('Parameter has to be positive.');
    } else {
      const sNumber = num.toString();
      // Java Version deckt hier auch römische Zahlen ab das dürfte hier aber egal sein
      return parseInt(sNumber.charAt(sNumber.length - 1), 10);
    }
  }

  public validate(tin: string): string | null {
    const normalizedTIN = tin ? tin.replace(/\//g, '').replace(/\s/g, '').replace(/\./g, '').replace(/-/g, '') : '';
    if (!this.isFollowLength(normalizedTIN)) {
      return ChAlgorithm.resultToString(4);
    } else if (this.isFollowLength(normalizedTIN) && !this.isFollowPattern(normalizedTIN)) {
      return ChAlgorithm.resultToString(3);
    } else {
      return !this.isFollowRules(normalizedTIN) ? ChAlgorithm.resultToString(1) : ChAlgorithm.resultToString(0);
    }
  }

  public isFollowLength(tin: string): boolean {
    return ChAlgorithm.LENGTH_PATTERN.test(tin);
  }

  public isFollowPattern(tin: string): boolean {
    return ChAlgorithm.PATTERN.test(tin);
  }

  public isFollowRules(tin: string): boolean {
    return this.isFollowLength(tin) && this.isFollowRuleSwiss(tin);
  }

  public isFollowRuleSwiss(tin: string): boolean {
    const c1 = parseInt(tin.charAt(0), 10);
    const c2 = parseInt(tin.charAt(1), 10);
    const c3 = parseInt(tin.charAt(2), 10);
    const c4 = parseInt(tin.charAt(3), 10);
    const c5 = parseInt(tin.charAt(4), 10);
    const c6 = parseInt(tin.charAt(5), 10);
    const c7 = parseInt(tin.charAt(6), 10);
    const c8 = parseInt(tin.charAt(7), 10);
    const c9 = parseInt(tin.charAt(8), 10);
    const c10 = parseInt(tin.charAt(9), 10);
    const c11 = parseInt(tin.charAt(10), 10);
    const c12 = parseInt(tin.charAt(11), 10);
    const c13 = parseInt(tin.charAt(12), 10);

    try {
      const sum = c1 + 3 * c2 + c3 + 3 * c4 + c5 + 3 * c6 + c7 + 3 * c8 + c9 + 3 * c10 + c11 + 3 * c12;
      const check = (10 - ChAlgorithm.getUnit(sum)) % 10;
      return c13 === check;
    } catch (e) {
      return false;
    }
  }
}
